import moment from 'moment';
import { map } from 'lodash/collection';
import { trim } from 'lodash/string';
import $ from 'jquery';
import { APP_UPDATE_HEADER_NAME } from './constants';

import ClientStorage from '../util/ClientStorage';

// For getting nested items from Immutable.js Map with dot notation
export const getWithDot = (m, path) => (
  m.getIn(path.split('.'))
);

export const trimResourceNames = resources => (
  map(resources, resource => ({
    ...resource,
    name: trim(resource.name).replace(/^\w\s+/, '')
  }))
);

export const checkAppUpdate = (response) => {
  // console.log('>>check for updated...<<');
  if (response.headers && response.headers[APP_UPDATE_HEADER_NAME]) {
    // set this in the storage but do not trigger the full refresh yet
    ClientStorage.setAppBuildTimestamp(APP_UPDATE_HEADER_NAME);
  }
};

export const htmlDecode = (input) => {
  const doc = new DOMParser().parseFromString(input, 'text/html');
  return doc.documentElement.textContent;
};

export const isElementVisible = (element) => {
  const docViewTop = $(window).scrollTop();
  const docViewBottom = docViewTop + $(window).height();

  const elemTop = $(element).offset().top;
  const elemBottom = elemTop + $(element).height();

  return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
};

export const transformReservationsToTimeSlot = (reservation, resources, t) => {
  const timeSlot = Object.assign({}, reservation);
  const resource = resources[reservation.resource];
  // type 1 is person 
  if (resource && resource.type === 1) {
    const { speciality } = resource;
    const resourceType = t(`resources.time_type_${resource.type}`,
      { defaultValue: t(`resources.${Array.isArray(speciality) ? speciality[0] : speciality}`, { defaultValue: '' }) });
    timeSlot.resourceType = resourceType;
    timeSlot.resourceName = resource.name;
  }

  timeSlot.timeMoment = moment(reservation.start);
  timeSlot.reservation = reservation.reservation;
  return timeSlot;
};

export const cyrillicLetterScanner = (string) => {
  const CYRILLIC_PATTERN_REGEX = /^[\u0400-\u04FF]+$/;
  return trim(string).split('').some(letter => letter.match(CYRILLIC_PATTERN_REGEX));
};

export const TIME_SLOT_IN_THE_PAST = 'TIME_SLOT_IN_THE_PAST';

export const isTimeSlotInThePast = timeSlot => !!(
  timeSlot && timeSlot.timeMoment && moment(timeSlot.timeMoment).isBefore(moment())
);



// WEBPACK FOOTER //
// ./src/util/helpers.js